module.exports = __webpack_public_path__ + "img/btn4.1718f89a.png";